import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'
import Login from '../views/Login'
import Dashboard from '../views/Dashboard'
import Settings from '../views/Settings'
import Profile from '../views/Profile'
import BankFeed from '../views/BankFeed'
import Transaction from '../views/Transaction'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Dashboard',
    component: Dashboard
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/settings',
    name: 'Settings',
    component: Settings
  },
  {
    path: '/my-profile',
    name: 'Profile',
    component: Profile
  },
  {
    path: '/bank-feed',
    name: 'BankFeed',
    component: BankFeed
  },
  {
    path: '/transactions',
    name: 'Transaction',
    component: Transaction
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if (!store.state.auth && to.name !== 'Login') next({ name: 'Login' })
  if (store.state.auth && to.name === 'Login') next({ name: 'Dashboard' })
  else next()
})

export default router
